import { render } from "./MainMenu.vue?vue&type=template&id=7132eb51"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/karsten/Dropbox (Privat)/htdocs/wintitower/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__